// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__3PvPc","main":"Layout_main__1dFZc","main-content":"Layout_main-content__300Iy"};